export default {
  // Customers
  customers: {
    createNew: 'Create New Customer',
    phoneNumber: 'Phone Number',
    name: 'Customer Name',
    enterName: 'Enter customer name',
    externalReference: 'External Reference',
    enterExternalReference: 'Enter external reference (optional)',
    search: 'Search Customers',
    noResults: 'No customers found',
    create: 'Create Customer',
    edit: 'Edit Customer',
    details: 'Customer Details',
    contactInfo: 'Contact Information',
    management: 'Customer Management',
    managementDescription: 'View and manage customer information and ticket history',
    searchPlaceholder: 'Search by name, phone, or external reference...',
    totalCustomers: 'Total Customers',
    loadingCustomers: 'Loading customers...',
    noCustomersFound: 'No customers found matching your search',
    noCustomersYet: 'No customers yet',
    tableHeaders: {
      customer: 'Customer',
      phone: 'Phone',
      externalRef: 'External Ref',
      created: 'Created',
      actions: 'Actions'
    },
    deleteCustomerTitle: 'Delete customer',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete customer',
    confirmDeleteWarning: 'This action cannot be undone.',
    deleteSuccess: 'Customer deleted successfully',
    deleteFailed: 'Failed to delete customer',
    deleting: 'Deleting...',
    delete: 'Delete'
  },

  // Languages
  languages: {
    en: 'English',
    my: 'မြန်မာ'
  },

  // Notifications
  notifications: {
    disableSound: 'Disable notification sound',
    enableSound: 'Enable notification sound',
    newTicket: 'New ticket created',
    ticketUpdated: 'Ticket #{{id}} updated',
    ticketAssigned: 'Ticket assigned to you',
    ticketResolved: 'Ticket resolved',
    ticketClosed: 'Ticket closed',
    received: 'Notification received',
    markAllReadError: 'Failed to mark all notifications as read. Please try again.',
    noAssociatedTicket: 'This notification does not have an associated ticket.',
    navigationError: 'Could not navigate to ticket. Please try again.'
  },

  // Authentication
  auth: {
    loginFailed: 'Login failed',
    organizationSubdomain: 'Organization Subdomain',
    subdomainRequired: 'Organization subdomain is required',
    invalidSubdomain: 'Invalid subdomain format',
    subdomainPlaceholder: 'your-organization',
    subdomainHelpText:
      "Enter your organization's subdomain to connect to the correct tenant. If you don't know your organization's subdomain, please contact your administrator.",
    loggingIntoOrg: 'You are logging into the',
    devMode: '(Local development mode)',
    emailAddress: 'Email address',
    emailRequired: 'Email is required',
    invalidEmail: 'Invalid email address',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordPlaceholder: 'Enter your password',
    forgotPassword: 'Forgot password?',
    signingIn: 'Signing in...',
    signIn: 'Sign in',
    forgotPasswordTitle: 'Forgot Password?',
    contactAdmin: 'Please contact your system administrator to reset your password.',
    email: 'Email: ',
    phone: 'Phone: '
  },

  // Forms
  forms: {
    fieldRequired: '{{field}} is required',
    selectField: 'Select {{field}}',
    enterToSearch: 'Enter to search',
    priorityLevel: 'Priority Level',
    priorityLevelDescription: 'Set the urgency of this ticket',
    ticketMainInfo: 'Classification',
    ticketMainInfoDescription: 'Tag and categorize this ticket',
    assignmentTitle: 'Assignment',
    assignmentDescription: ' Assign this ticket to respective Agent',
    ticketDetailTitle: 'Ticket Details',
    ticketDetailDescription: 'Add description, templates, and attachments',
    description: 'Ticket Description',
    attachments: 'Attachments',
    validation: {
      required: 'This field is required',
      minLength: 'Must be at least {{min}} characters',
      maxLength: 'Must not exceed {{max}} characters',
      invalidFormat: 'Invalid format'
    }
  },

  // Common UI elements
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    noData: 'No data available',
    none: 'None',
    email: 'Email',
    phone: 'Phone',
    createTicket: 'Create Ticket',
    submit: 'Submit',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    test: 'Test',
    testing: 'Testing...',
    comingSoon: 'Coming Soon',
    openInNewTab: 'Open in new tab',
    unknownError: 'Unknown error',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    apply: 'Apply',
    to: 'to',
    create: 'Create',
    creating: 'Creating...',
    settings: 'Settings',
    appLogo: 'FlowCXP Logo',
    appName: 'FlowCXP',
    profile: 'Profile',
    logout: 'Logout',
    notifications: 'Notifications',
    markAllAsRead: 'Mark all as read',
    noNotifications: 'No unread notifications',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connectionError: 'Connection Error',
    language: 'Language',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    fullScreen: 'Full Screen',
    exitFullScreen: 'Exit Full Screen',
    changeLanguage: 'Change language',
    localizationTest: 'Localization Test Page',
    currentSettings: 'Current Settings',
    currentLanguage: 'Current Language',
    currentTheme: 'Current Theme',
    dark: 'Dark',
    light: 'Light',
    translationSamples: 'Translation Samples',
    commonElements: 'Common UI Elements',
    apiExamples: 'API Date Formatting Examples',
    accessDenied: 'Access Denied',
    accessDeniedMessage:
      "You don't have permission to access this resource. Please contact your administrator.",
    returnToDashboard: 'Return to Dashboard',
    previous: 'Previous',
    next: 'Next',
    showing: 'Showing',
    of: 'of',
    error404: "The page you're looking for doesn't exist.",
    error401: "You're not authorized to access this page.",
    error403: "You don't have permission to access this page.",
    error503: 'This service is currently unavailable.',
    errorGeneric: 'Something went wrong.',
    errorUnexpected: 'An unexpected error occurred.',
    applicationError: 'Application Error',
    goBack: 'Go Back',
    goHome: 'Go Home',
    unknown: 'Unknown'
  },

  // Tenant Information
  tenantInfo: {
    organizationInformation: 'Organization Information',
    active: 'Active',
    organizationName: 'Organization Name',
    subdomain: 'Subdomain',
    tenantId: 'Tenant ID',
    totalAgents: 'Total Agents'
  },

  // Organization & Department Management
  organization: {
    departments: {
      title: 'Departments',
      addDepartment: 'Add Department',
      editDepartment: 'Edit Department',
      searchPlaceholder: 'Search departments...',
      loading: 'Loading...',
      tableHeaders: {
        name: 'Name',
        description: 'Description',
        manager: 'Manager',
        actions: 'Actions'
      },
      noManagerAssigned: 'No manager assigned',
      selectManager: 'Select a manager',
      confirmDelete: 'Confirm Delete',
      confirmDeleteMessage:
        'Are you sure you want to delete this department? This action cannot be undone.',
      saveFailed: 'Failed to save department',
      deleteFailed: 'Failed to delete department. Ensure no users are assigned to it.'
    },
    myOrganization: {
      title: 'My Organization',
      loadingData: 'Loading organization data...',
      department: 'Department',
      selectDepartment: 'Select Department',
      manager: 'Manager',
      change: 'Change',
      addManager: '+ Add Manager',
      myTeam: 'My Team',
      addMember: '+ Add Member',
      noDirectReports: 'No direct reports',
      relationshipRequests: 'Relationship Requests',
      incomingRequests: 'Incoming Requests',
      outgoingRequests: 'Outgoing Requests',
      wantsToBe: 'wants to be your',
      relationshipTypes: {
        manager: 'Manager',
        subordinate: 'Subordinate'
      },
      noIncomingRequests: 'No incoming requests',
      youAsked: 'You asked',
      toBe: 'to be your',
      pending: 'Pending',
      noOutgoingRequests: 'No outgoing requests',
      selectYourManager: 'Select Your Manager',
      addTeamMember: 'Add Team Member',
      selectUser: 'Select User',
      selectUserPlaceholder: 'Select a user...',
      sendRequest: 'Send Request',
      requestFailed: 'Failed to send request'
    }
  },

  // Pages
  pages: {
    login: {
      title: 'Login',
      welcomeBack: 'Welcome back!',
      signInToContinue: 'Sign in to continue',
      newToApp: 'New to the app?',
      registerOrg: 'Register an organization',
      loggingIn: 'Logging in...',
      connecting: 'Connecting to tenant...',
      subdomain: 'Organization Subdomain',
      subdomainPlaceholder: 'your-organization',
      subdomainHelpText:
        "Enter your organization's subdomain to connect to the correct tenant. If you don't know your organization's subdomain, please contact your administrator.",
      domain: '.flowcxp.com',
      loggingIntoOrg: 'You are logging into the',
      devMode: '(Local development mode)',
      emailAddress: 'Email address',
      emailRequired: 'Email is required',
      invalidEmail: 'Invalid email address',
      emailPlaceholder: 'you@example.com',
      password: 'Password',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Password must be at least 6 characters',
      passwordPlaceholder: 'Enter your password',
      forgotPassword: 'Forgot password?',
      signingIn: 'Signing in...',
      signIn: 'Sign in',
      forgotPasswordTitle: 'Forgot Password?',
      contactAdmin: 'Please contact your system administrator to reset your password.',
      email: 'Email: ',
      phone: 'Phone: '
    },
    createTicket: {
      title: 'Create Ticket',
      description: 'Fill in the details to create a new support ticket',
      createButton: 'Create Ticket',
      error: 'Failed to create ticket. Please try again.',
      fields: {
        title: 'Title',
        titlePlaceholder: 'Enter ticket title',
        titleToggle: {
          auto: 'Auto-generated',
          manual: 'Manual entry'
        },
        description: 'Description',
        descriptionPlaceholder: 'Enter ticket description',
        searchCustomer: 'Search Customer',
        searchCustomerByPhone: 'Search customer by phone number',
        searching: 'Searching...',
        search: 'Search',
        foundCustomers: 'Found {{count}} customers',
        foundCustomersPlural: 'Found {{count}} customers',
        select: 'Select',
        edit: 'Edit',
        priority: 'Priority',
        status: 'Status',
        assignee: 'Assignee',
        category: 'Category',
        type: 'Type',
        source: 'Source',
        tags: 'Tags',
        attachments: 'Attachments',
        comments: 'Comments',
        assignToAgent: 'Assign to Agent',
        assignToGroup: 'Assign to Group',
        tagsPlaceholder: 'Select or search tags...',
        ticketDetails: 'Ticket Details',
        templates: 'Templates',
        selectTemplate: 'Select a form template',
        loadingTemplates: 'Loading templates...',
        notifyCustomer: 'Notify Customer',
        notifyCustomerDescription: 'Notify customer about the ticket via push notification'
      }
    },
    tickets: {
      title: 'Tickets',
      tags: 'Tags',
      groups: 'Groups',
      categories: 'Categories',
      sources: 'Sources',
      totalTickets: 'Total Tickets',
      allStatuses: 'All Statuses',
      requestedBy: 'Requested By',
      assignedTo: 'Assigned To',
      filterByGroups: 'Filter by groups...',
      filterByRequesters: 'Filter by requesters...',
      filterByAssignees: 'Filter by assignees...',
      filterByTags: 'Filter by tags...',
      filterByCategories: 'Filter by categories...',
      filterBySources: 'Filter by sources...',
      hideFilters: 'Hide Filters',
      showFilters: 'Show Filters',
      noTicketsFound: 'No tickets found',
      view: 'View',
      tableView: 'Table',
      listView: 'List',
      kanbanView: 'Kanban'
    },
    myMemo: {
      title: 'My Memo',
      newMemo: 'New Memo',
      arrangeInGrid: 'Arrange in Grid',
      loadError: 'Failed to load memos',
      createError: 'Failed to create memo',
      updateError: 'Failed to update memo',
      deleteError: 'Failed to delete memo',
      loginRequired: 'Please log in to view your memos',
      searchPlaceholder: 'Search memos...',
      memoCount: '{{count}} memos',
      noMemos: 'No memos yet',
      noMatchingMemos: 'No matching memos',
      tryDifferentSearch: 'Try a different search term',
      createFirstMemo: 'Create your first memo to get started',
      createNewMemo: 'Create New Memo'
    },
    ticketWall: {
      title: 'Ticket Wall'
    },
    dashboard: {
      title: 'Dashboard',
      overview: 'Overview',
      topContributors: 'Top Contributors',
      recentActivity: 'Recent Activity',
      ticketBreakdown: 'Ticket Breakdown',
      quickStats: 'Quick Stats',
      ticketStats: 'Ticket Statistics',
      exportData: 'Export Data',
      dateRangeReport: 'Date Range Report',
      ticketsExport: 'tickets',
      exporting: 'Exporting...',
      export: 'Export',
      preparingExport: 'Preparing export...',
      failedToLoadStats: 'Failed to load dashboard statistics'
    },
    reports: {
      title: 'Reports',
      export: 'Export',
      exporting: 'Exporting...',
      preparingExport: 'Preparing export...',
      ticketsExport: 'Tickets-Export',
      accessDenied: "You don't have permission to access reports"
    },
    settings: {
      title: 'Settings'
    },
    ticketDetail: {
      type: 'Type',
      category: 'Category',
      saveChanges: 'Save Changes',
      editTicket: 'Edit Ticket',
      cancel: 'Cancel',
      ticketDetail: 'Ticket Details',
      unassigned: 'Unassigned',
      assignToMe: 'Assign to me',
      source: 'Source',
      deleteTicket: 'Delete Ticket',
      noAttachments: 'No attachments for this ticket.',
      newAttachmentsPreview: 'New Attachments Preview',
      currentAttachments: 'Current Attachments',
      addNewAttachments: 'Add New Attachments',
      discussion: 'Discussion',
      requester: 'Requester',
      customer: 'Customer',
      group: 'Group',
      assignee: 'Assignee',
      tags: 'Tags',
      attachments: 'Attachments',
      ticketHistory: 'Ticket History',
      ticketUpdatedByAnotherUser:
        'Ticket has been updated by another user. Please cancel current edit and try again.'
    },
    myWorkspace: {
      title: 'My Workspace',
      myOpenTickets: 'My Open Tickets',
      myAssignedTickets: 'My Assigned Tickets',
      openTicketsDescription: 'Tickets you have created',
      assignedTicketsDescription: 'Tickets assigned to you',
      noOpenTickets: "You haven't created any tickets yet",
      noAssignedTickets: 'No tickets are currently assigned to you',
      createFirstTicket: 'Create your first ticket',
      ticketsAsRequester: 'As Requester',
      ticketsAsAgent: 'As Agent',
      totalOpen: 'Total Open',
      totalAssigned: 'Total Assigned'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with our team',
      contactInfo: 'Contact Information',
      officeHours: 'Office Hours',
      headquarters: 'Headquarters'
    },
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      success: 'Password updated successfully',
      failedToChange: 'Failed to update password',
      validation: {
        currentRequired: 'Current password is required',
        minLength: 'New password must be at least 6 characters',
        maxLength: 'New password must not exceed 50 characters',
        confirmRequired: 'Please confirm your new password',
        passwordsDontMatch: "Passwords don't match"
      },
      submit: 'Save'
    }
  },

  // Navigation
  navigation: {
    backTo: 'Back to',
    dashboard: 'Dashboard',
    tickets: 'Tickets',
    ticketWall: 'Ticket Wall',
    myWorkspace: 'My Workspace',
    reports: 'Reports',
    settings: 'Settings',
    myMemo: 'My Memo',
    myMemos: 'My Memos',
    changePassword: 'Change Password',
    contact: 'Contact',
    backToHome: 'Back to Home',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    localizationTest: 'Localization Test',
    features: 'Features',
    pricing: 'Pricing',
    atrium: 'The Atrium'
  },
  // Tickets
  tickets: {
    title: 'Title',
    kanban: {
      dragToReorder: 'Drag to update status'
    },
    status: {
      filterTitle: 'Status',
      all: 'All',
      new: 'New',
      unassigned: 'Unassigned',
      processing: 'Processing',
      resolved: 'Resolved',
      closed: 'Closed'
    },
    priority: 'Priority',
    assignedTo: 'Assigned To',
    requestedBy: 'Requested By',
    filterByGroups: 'Filter by groups...',
    filterByRequesters: 'Filter by requesters...',
    filterByAssignees: 'Filter by assignees...',
    noUsersAvailable: 'No users available',
    typeAtLeastOneChar: 'Type at least 1 character',
    noMatchingUsers: 'No matching users found',
    loadingUsers: 'Loading users...',
    allStatuses: 'All Statuses',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    dueDate: 'Due Date',
    category: 'Category',
    type: 'Type',
    source: 'Source',
    group: 'Group',
    tags: 'Tags',
    description: 'Description',
    comments: 'Comments',
    attachments: 'Attachments',
    addComment: 'Add Comment',
    adding: 'Adding...',
    commentRequired: 'Please enter a comment',
    commentMinLength: 'Comment must be at least 3 characters',
    commentPlaceholder: 'Type your comment here...',
    addAttachment: 'Add Attachment',
    updateStatus: 'Update Status',
    updatePriority: 'Update Priority',
    assign: 'Assign',
    unassign: 'Unassign',
    open: 'Open',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed',
    reopened: 'Reopened',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
    noTicketsFound: 'No tickets found',
    createNewTicket: 'Create New Ticket',
    filterByStatus: 'Filter by Status',

    commentDeletedSuccess: 'Comment deleted successfully',
    commentDeleteFailed: 'Failed to delete comment',
    commentCannotBeEmpty: 'Comment cannot be empty',
    commentUpdateFailed: 'Failed to update comment',
    editComment: 'Edit comment',
    deleteComment: 'Delete comment',
    uploadFiles: 'Upload files',
    orDragAndDrop: 'or drag and drop',
    fileSizeLimit: 'Any file up to 10MB',
    deleteAttachment: 'Delete attachment',
    download: 'Download',
    created: 'Created',
    updated: 'Updated',
    ticketNumber: 'Ticket #',
    lastUpdated: 'Last Updated',
    imagePasted: 'Image pasted as attachment',
    maxAttachmentReached: 'Maximum {{max}} attachments allowed',
    statusCounts: {
      total: 'Total',
      new: 'New',
      processing: 'Processing',
      resolved: 'Resolved',
      closed: 'Closed',
      assigned: 'Assigned',
      unassigned: 'Unassigned'
    },
    sources: {
      email: 'Email',
      phone: 'Phone',
      chat: 'Chat',
      web: 'Web Portal'
    },
    groups: {
      techops: 'TechOps',
      backops: 'BackOps',
      biller: 'Biller Support'
    },
    types: {
      request: 'Request',
      complaint: 'Complaint'
    },
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent'
    },
    totalTickets: 'Total Tickets',
    resolvedTickets: 'Resolved Tickets',
    closedTickets: 'Tickets Completed',
    averageResponseTime: 'Average Response Time',
    averageResolutionTime: 'Average Resolution Time',
    columns: {
      id: 'ID',
      title: 'Title',
      customer: 'Customer',
      status: 'Status',
      priority: 'Priority',
      type: 'Type',
      category: 'Category',
      source: 'Source',
      assignedTo: 'Assigned To',
      createdAt: 'Created At'
    },
    unassigned: 'Unassigned',
    private: 'Private',
    categories: {
      technical: 'Technical',
      billing: 'Billing',
      feature: 'Feature',
      account: 'Account',
      other: 'Other'
    },

    bulkActions: {
      changeStatus: 'Change Status',
      confirmTitle: 'Confirm Status Change',
      confirmMessage:
        'Are you sure you want to change the status of {{count}} tickets to <strong>{{status}}</strong>? This action cannot be undone.',
      confirm: 'Confirm'
    },

    selected: 'Selected',
    removeAttachment: 'Remove Attachment',
    maxFileSize: 'Max 50MB per file',
    uploadFile: 'Upload a file',
    dragndrop: ' or drag and drop'
  },
  // Date and Time
  dateTime: {
    title: 'Date & Time Formatting',
    dateFormat: 'MMM d, yyyy',
    timeFormat: 'h:mm a',
    dateTimeFormat: 'MMM d, yyyy h:mm a',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    now: 'Now',
    justNow: 'Just now',
    invalidDateRange: 'Start date must be earlier than or equal to end date',
    minutesAgo: '{{count}} minute ago',
    minutesAgo_plural: '{{count}} minutes ago',
    hoursAgo: '{{count}} hour ago',
    hoursAgo_plural: '{{count}} hours ago',
    daysAgo: '{{count}} day ago',
    daysAgo_plural: '{{count}} days ago',
    timezone: 'Timezone',
    myanmarTimezone: 'Myanmar Time (UTC+06:30)',
    formats: 'Date Formats',
    currentDate: 'Current Date',
    currentDateTime: 'Current Date & Time',
    apiFormat: 'API Format',
    dateRange: 'Date Range',
    parsing: 'Date Parsing',
    parsedDate: 'Parsed Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    currentMyanmarTime: 'Current Myanmar Time',
    systemTime: 'System Time',
    apiFormats: 'API Date Formats with Myanmar Timezone',
    startOfDay: 'Start of Day',
    endOfDay: 'End of Day',
    startOfDayDesc: 'Sets time to 00:00:00 with +06:30 timezone offset',
    endOfDayDesc: 'Sets time to 23:59:59 with +06:30 timezone offset',
    dateRangeExample: 'Date Range Example',
    apiRequestExample: 'API Request Example',
    apiDateComment: 'Myanmar timezone (UTC+06:30) is explicitly set for API requests',
    rawFormats: 'Raw Date Format Comparison',
    formattedWithUtils: 'Formatted with our utils',
    apiFormatted: 'API Formatted (Myanmar Timezone)',
    filterStartHint: 'Start: 12:00 AM',
    filterEndHint: 'End: 11:59 PM'
  },
  // Profile
  profile: {
    uploadPicture: 'Upload profile picture',
    selectImageFile: 'Please select an image file',
    imageSizeLimit: 'Image size should be less than 5MB',
    uploadSuccess: 'Profile picture uploaded successfully',
    uploadFailed: 'Failed to upload profile picture',
    changePassword: 'Change Password',
    personalInfo: 'Personal Information',
    updateProfile: 'Update Profile',
    fullName: 'Full Name',
    email: 'Email',
    role: 'Role',
    lastLogin: 'Last Login',
    joinedOn: 'Joined On'
  },
  // Metadata
  metadata: {
    addNew: 'Add New',
    edit: 'Edit',
    save: 'Save',
    create: 'Create',
    delete: 'Delete',
    name: 'Name',
    description: 'Description',
    actions: 'Actions',
    confirmDelete: 'Confirm Delete',
    deleteConfirmation: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
    failedToFetch: 'Failed to fetch items',
    failedToSave: 'Failed to save item',
    failedToDelete: 'Failed to delete item'
  },
  // Page titles and headers
  pageHeaders: {
    dashboard: {
      title: 'Dashboard',
      enhancedTitle: 'Dashboard',
      enhancedSubtitle: 'Advanced analytics and insights for your tickets',
      topContributors: 'Top Contributors',
      failedToLoadContributors: 'Failed to load top contributors',
      failedToLoadTicketTrends: 'Failed to load ticket trends',
      failedToLoadTrends: 'Failed to load ticket trends',
      failedToLoadStats: 'Failed to load dashboard statistics',
      createdTickets: 'Created Tickets',
      closedTickets: 'Closed Tickets',
      tickets: 'tickets',
      overview: 'Overview',
      quickStats: 'Quick Stats',
      ticketBreakdown: 'Ticket Breakdown',
      recentActivity: 'Recent Activity',
      // Enhanced Dashboard
      ticketTrends: 'Ticket Trends',
      trendsDescription: 'Daily ticket creation and resolution patterns',
      statusBreakdown: 'Status Breakdown',
      statusDescription: 'Distribution of tickets by current status',
      priorityDistribution: 'Priority Distribution',
      priorityDescription: 'Breakdown of tickets by priority level',
      contributorsDescription: 'Most active team members by tickets resolved',
      ticketsCreated: 'Tickets Created',
      ticketsClosed: 'Tickets Closed',
      netChange: 'Net Change',
      efficiency: 'Efficiency',
      totalCreated: 'Total Created',
      totalClosed: 'Total Closed',
      backlogIncreased: 'Backlog increased',
      backlogDecreased: 'Backlog decreased',
      backlogStable: 'Backlog stable',
      noTrendData: 'No trend data available for the selected date range',
      totalTickets: 'Total Tickets',
      quickInsights: 'Quick Insights',
      newTicketsNeedAttention: 'new tickets need attention',
      ticketsInProgress: 'tickets currently in progress',
      ticketsAwaitingClosure: 'tickets awaiting closure',
      ticketCount: 'Ticket Count',
      averagePriority: 'Average Priority Score',
      priorityScoreDesc: 'Weighted average (1=Low, 4=Urgent)',
      urgentAttention: 'Urgent Attention Required',
      urgentTicketsMessage: 'urgent tickets require immediate attention',
      // Performance Metrics
      completionRate: 'Completion Rate',
      ticketsCompleted: 'Tickets completed',
      avgResponseTime: 'Avg Response Time',
      averageFirstResponse: 'Average first response',
      activeTickets: 'Active Tickets',
      newAndProcessing: 'New and processing',
      performanceSummary: 'Performance Summary',
      workloadDistribution: 'Workload Distribution',
      newTickets: 'New',
      processing: 'Processing',
      resolved: 'Resolved',
      priorityBreakdown: 'Priority Breakdown',
      urgent: 'Urgent',
      high: 'High',
      medium: 'Medium',
      keyInsights: 'Key Insights',
      excellentCompletion: 'Excellent completion rate',
      noUrgentTickets: 'No urgent tickets',
      managableWorkload: 'Manageable workload',
      active: 'Active',
      // Top Contributors
      progress: 'Progress',
      inProgress: 'in progress',
      total: 'total',
      noContributorsData: 'No contributor data available for the selected date range',
      teamSummary: 'Team Summary',
      totalResolved: 'Total Resolved',
      totalInProgress: 'Total In Progress',
      topPerformer: 'Top Performer',
      errorTitle: 'Error Loading Dashboard',
      searchError: 'Search error',
      separator: '•',
      allTimeTotal: 'All time total',
      dayAverage: '/day avg',
      backlogGrew: 'Backlog grew',
      backlogShrank: 'Backlog shrank',
      stable: 'Stable',
      resolutionRate: 'Resolution rate'
    },
    tickets: {
      title: 'Tickets',
      allTickets: 'All Tickets',
      viewMode: 'View Mode',
      list: 'List',
      table: 'Table',
      kanban: 'Kanban',
      filterTickets: 'Filter Tickets',
      ticketDetails: 'Ticket Details',
      view: 'View',
      tableView: 'Table',
      listView: 'List',
      kanbanView: 'Kanban Board',
      totalTickets: 'Total Tickets',
      allStatuses: 'All Statuses',
      requestedBy: 'Requested By',
      assignedTo: 'Assigned To',
      filterByGroups: 'Filter by groups...',
      filterByRequesters: 'Filter by requesters...',
      filterByAssignees: 'Filter by assignees...',
      hideFilters: 'Hide Filters',
      showFilters: 'Show Filters',
      noTicketsFound: 'No tickets found',
      kanbanBoard: {
        dragToReorder: 'Drag to reorder',
        private: 'Private',
        createdBy: 'Created by:',
        assignedTo: 'Assigned to:',
        created: 'Created',
        updated: 'Updated'
      }
    },
    createTicket: {
      title: 'Create Ticket',
      newTicket: 'New Ticket',
      basicInfo: 'Basic Information',
      additionalDetails: 'Additional Details',
      error: 'Failed to create ticket',
      createButton: 'Create Ticket',
      fields: {
        title: 'Ticket Title',
        titlePlaceholder: 'Brief summary of the issue',
        source: 'Source',
        category: 'Category',
        type: 'Type',
        assignToGroup: 'Assign to Group',
        assignToAgent: 'Assign to Agent',
        tags: 'Tags',
        tagsPlaceholder: 'Select or search tags...',
        noTagsAvailable: 'No tags available',
        typeAtLeastOneChar: 'Type at least 1 character',
        noMatchingTags: 'No matching tags found',
        loadingTags: 'Loading tags...',
        ticketDetails: 'Ticket Details',
        description: 'Description',
        descriptionPlaceholder: 'Detailed description of the issue...',
        templates: 'Templates',
        selectTemplate: 'Select a form template',
        loadingTemplates: 'Loading templates...',
        notifyCustomer: 'Notify Customer',
        notifyCustomerDescription: 'Notify customer about the ticket via push notification'
      }
    },
    reports: {
      title: 'Reports',
      ticketStats: 'Ticket Statistics',
      exportData: 'Export Data',
      dateRangeReport: 'Date Range Report',
      ticketsExport: 'tickets',
      exporting: 'Exporting...',
      export: 'Export'
    },
    settings: {
      title: 'Settings',
      account: 'Account',
      preferences: 'Preferences',
      notifications: 'Notifications',
      security: 'Security'
    },
    myMemo: {
      title: 'My Memos',
      createMemo: 'Create Memo',
      editMemo: 'Edit Memo',
      deleteMemo: 'Delete Memo',
      newMemo: 'New Memo',
      arrangeInGrid: 'Arrange in Grid',
      loadError: 'Failed to load memos',
      createError: 'Failed to create memo',
      updateError: 'Failed to update memo',
      deleteError: 'Failed to delete memo',
      loginRequired: 'Please log in to view your memos',
      searchPlaceholder: 'Search memos...',
      memoCount: '{{count}} memos',
      noMemos: 'No memos yet',
      noMatchingMemos: 'No matching memos',
      tryDifferentSearch: 'Try a different search term',
      createFirstMemo: 'Create your first memo to get started',
      createNewMemo: 'Create New Memo'
    },
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      success: 'Password changed successfully',
      failedToChange: 'Failed to change password',
      validation: {
        currentRequired: 'Current password is required',
        minLength: 'New password must be at least 6 characters',
        maxLength: 'New password must not exceed 50 characters',
        confirmRequired: 'Please confirm your new password',
        passwordsDontMatch: "Passwords don't match"
      }
    },
    contact: {
      title: 'Contact',
      contactForm: 'Contact Form',
      sendMessage: 'Send Message',
      contactInfo: 'Contact Information',
      subtitle: 'Get in touch with our team',
      officeHours: 'Office Hours',
      headquarters: 'Headquarters'
    },
    privacyPolicy: {
      title: 'Privacy Policy'
    },
    termsOfService: {
      title: 'Terms of Service'
    },
    landing: {
      title: 'FlowCXP - Customer Experience Platform',
      subtitle: 'Streamline your customer support with our modern ticketing system',
      nav: {
        signIn: 'Sign In',
        getStarted: 'Get Started'
      },
      hero: {
        transparentPricing: 'Transparent pricing at $15-20/agent',
        premiumFeatures: 'ALL premium features included',
        exceptionalValue: 'Exceptional value for teams of any size',
        modernInterface: 'Lightning-fast modern React interface',
        realtimeUpdates: 'Real-time updates and notifications',
        boostProductivity: 'Boost team productivity by 40%',
        comprehensiveFeatures: 'Comprehensive feature set',
        everyFeature: 'Every feature included on every plan',
        predictablePricing: 'Predictable pricing, no surprises',
        startTrial: 'Start Free 14-Day Trial',
        noCreditCard: 'No credit card required. Full access to all features.'
      },
      featuresTitle: 'Designed for Modern Support Teams',
      features: {
        dashboard: {
          name: 'Intuitive Dashboard',
          description:
            'Get a comprehensive overview of all your support activities with our customizable dashboard.',
          alt: 'Dashboard interface showing ticket statistics and activity'
        },
        views: {
          name: 'Flexible Views',
          description:
            'Switch between kanban, table, and card views to manage your workflow exactly how you want.',
          alt: 'Kanban board view of tickets'
        },
        ticketManagement: {
          name: 'Detailed Ticket Management',
          description: 'Access all ticket details in one place with our comprehensive ticket view.',
          alt: 'Detailed ticket view with all information'
        },
        reporting: {
          name: 'Advanced Reporting',
          description: 'Generate insightful reports to track performance and identify trends.',
          alt: 'Reporting interface with charts and metrics'
        }
      },
      platformHighlights: 'Platform Highlights',
      pricing: {
        title: 'Tailored Solutions for Your Business',
        description:
          'All FlowCXP features—ticketing, workflows, analytics, portal, integrations—designed to scale with your organization.',
        period: 'pricing',
        enterprise: {
          name: 'Enterprise',
          price: 'Custom',
          description:
            'Tailored pricing, SLAs, and deployment options for businesses of all sizes.',
          seatLimit: 'Any team size',
          cta: 'Request Demo',
          features: {
            all: 'All FlowCXP features included',
            ticketing: 'Complete ticketing system',
            workflows: 'Unlimited workflows & automations',
            sla: 'Custom SLAs and deployment options',
            accountManager: 'Dedicated account manager',
            prioritySupport: 'Priority support',
            integrations: 'Custom integrations'
          }
        }
      },
      forgotPassword: 'Forgot Password'
    },
    login: {
      title: 'Login',
      welcome: 'Welcome',
      credentials: 'Sign in with your credentials',
      forgotPassword: 'Forgot Password'
    },
    registration: {
      title: 'Registration',
      createAccount: 'Create Account',
      alreadyHaveAccount: 'Already have an account'
    },
    checkout: {
      title: 'Checkout',
      paymentDetails: 'Payment Details',
      billingInfo: 'Billing Information',
      invalidPlan: 'Invalid plan selected',
      planNotFound: 'Plan not found',
      backToPricing: 'Back to Pricing',
      subscribingTo: 'Subscribing to {{planName}}'
    },
    paymentSuccess: {
      title: 'Payment Successful',
      thankYou: 'Thank you for your purchase',
      orderDetails: 'Order Details'
    }
  },
  // Search
  search: {
    placeholder: 'Search tickets... (e.g. @ticket_id: 123)',
    criteria: {
      ticketId: 'Ticket ID',
      ticketTitle: 'Ticket Title',
      ticketDescription: 'Ticket Description',
      customerId: 'Customer ID',
      customerName: 'Customer Name',
      customerPhone: 'Customer Phone',
      customerReference: 'Customer Reference'
    }
  },

  // Settings
  settings: {
    manageAgents: 'Manage Agents',
    availableAgents: 'Available Agents',
    currentAgents: 'Current Agents',
    addSelected: 'Add Selected',
    removeSelected: 'Remove Selected',
    failedToLoadAgents: 'Failed to load agents',
    failedToAddAgents: 'Failed to add agents',
    failedToRemoveAgents: 'Failed to remove agents',
    title: 'Settings',
    sources: 'Sources',
    categories: 'Categories',
    types: 'Types',
    agents: 'Agents',
    groups: 'Groups',
    tags: 'Tags',
    templates: 'Templates',
    integrations: 'Integrations',
    omnichannel: 'Omni-Channel',
    email: 'Email',
    botConfiguration: 'Bots',
    billing: 'Billing',
    auditLogs: 'Logs',
    accessDenied: "You don't have permission to view settings. Please contact your administrator.",
    billingAccessDenied:
      "You don't have permission to access billing settings. This feature requires super admin privileges.",
    userManagement: {
      title: 'Support Agents',
      description: 'Manage support agents who can handle tickets',
      addNew: 'Add New',
      me: 'Me',
      resetPassword: 'Reset password',
      cannotDeleteOwnAccount: 'You cannot delete your own account',
      deleteAgent: 'Delete Agent',
      confirmDelete: 'Are you sure you want to delete',
      tempPasswordGenerated: 'Temporary Password Generated',
      resetPasswordTitle: 'Reset Password',
      confirmResetPassword: 'Are you sure you want to reset the password for',
      tempPasswordMessage: 'A temporary password has been generated for',
      copyToClipboard: 'Copy to clipboard',
      editAgent: 'Edit',
      addAgent: 'Add',
      fullName: 'Full Name',
      phone: 'Phone',
      email: 'Email',
      password: 'Password',
      role: 'Role',
      totalAgents: 'Total Agents',
      roles: {
        agent: 'Agent',
        admin: 'Admin',
        requester: 'Requester'
      },
      saveChanges: 'Save Changes',
      create: 'Create',
      columns: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        role: 'Role',
        actions: 'Actions'
      },
      errors: {
        fetchFailed: 'Failed to fetch users',
        saveFailed: 'Failed to save user',
        deleteFailed: 'Failed to delete user'
      },
      success: {
        userSaved: 'User saved successfully',
        userDeleted: 'Successfully deleted user'
      }
    },
    categoryManagement: {
      title: 'Categories',
      description: 'Configure different categories to classify tickets'
    },
    typeManagement: {
      title: 'Types',
      description: 'Configure different types of tickets that can be created'
    },
    sourceManagement: {
      title: 'Sources',
      description: 'Configure different sources and channels through which tickets can be created'
    },
    groupManagement: {
      title: 'Groups',
      description: 'Configure different groups to classify tickets'
    },
    tagManagement: {
      title: 'Tags',
      description: 'Configure tags for better ticket organization and filtering',
      titleSuggestions: 'Title Suggestions',
      addTitleSuggestion: 'Add Title Suggestion',
      editTitleSuggestion: 'Edit Title Suggestion',
      deleteTitleSuggestion: 'Delete Title Suggestion',
      titleSuggestionPlaceholder: 'Enter a suggested title for this tag',
      noTitleSuggestions: 'No title suggestions yet',
      titleSuggestionsDescription: 'Add suggested ticket titles for this tag',
      usageCount: 'Used {{count}} times',
      confirmDeleteTitle: 'Are you sure you want to delete this title suggestion?',
      titleAdded: 'Title suggestion added',
      titleDeleted: 'Title suggestion deleted',
      titleLoadError: 'Failed to load title suggestions',
      titleAddError: 'Failed to add title suggestion',
      titleDeleteError: 'Failed to delete title suggestion',
      invalidTitleFormat: 'Title contains invalid characters or HTML tags'
    },
    ticketTitleSuggestions: {
      title: 'Suggestions',
      description: 'Configure automatic ticket title suggestions based on selected tags',
      enableFeature: 'Enable Title Suggestions',
      enableDescription:
        'When enabled, users will see suggested titles based on selected tags when creating tickets',
      manageSuggestions: 'Manage Suggestions',
      manageSuggestionsDescription:
        'Add and manage title suggestions for each tag in the Tags settings',
      noSuggestionsAvailable: 'No suggestions available for selected tags',
      selectFromSuggestions: 'Select from suggestions or enter manually',
      suggestedTitles: 'Suggested Titles',
      enterManually: 'Or enter title manually',
      autoGenerated: 'Title is auto-generated based on selected tags',
      settingsSaved: 'Ticket title suggestions settings saved',
      settingsError: 'Error saving settings',
      autoTitleToggle: 'Auto-Generate Titles',
      autoTitleDescription: 'Automatically fill ticket title based on selected tags'
    },
    templateManagement: {
      title: 'Templates',
      description: 'Configure templates for ticket creation'
    },
    integrationManagement: {
      contentTypeDescription: 'Content-Type header for the API request',
      testTitle: 'Test Integration',
      testDescription: 'Test the connection to the external reference service'
    },
    emailSettings: {
      title: 'Email Settings',
      description: 'Configure email channel settings and default ticket values',
      receivingAddress: 'Customer Support Email Address',
      addressHelp: 'Share this email with customers or forward your support emails here',
      addressCopied: 'Email address copied to clipboard',
      defaultSettings: 'Default Ticket Settings',
      defaultSettingsHelp: 'These values will be applied to tickets created from incoming emails',
      defaultPriority: 'Default Priority',
      defaultCategory: 'Default Category',
      defaultType: 'Default Type',
      defaultSource: 'Default Source',
      defaultTags: 'Default Tags',
      defaultGroup: 'Assign to Group',
      defaultAgent: 'Assign to Agent',
      anyAgent: 'Any Agent',
      noChannel: 'No email channel configured',
      loadError: 'Failed to load email configuration',
      saveSuccess: 'Email settings saved successfully',
      saveError: 'Failed to save email settings'
    },
    integrationSettings: {
      externalReference: {
        title: 'External Reference Integration',
        description:
          'Configure external reference integration settings for automatic customer data lookup',
        enable: 'Enable External Reference Integration',
        enableDescription: 'Enable integration with external reference ID service',
        apiUrl: 'API URL',
        apiUrlDescription: 'The base URL of the external reference service API',
        apiKey: 'API Key',
        apiKeyDescription: 'Authentication key for accessing the external reference service',
        apiKeyPlaceholder: 'Enter your API key',
        apiKeyHeader: 'API Key Header Name',
        apiKeyHeaderDescription:
          'Header name for the API key (e.g., "key", "Authorization", "X-API-Key")',
        apiKeyHeaderPlaceholder: 'Authorization',
        contentType: 'Content Type',
        contentTypeDescription: 'Content-Type header for API requests',
        timeout: 'Timeout (seconds)',
        timeoutDescription: 'Request timeout in seconds (default: 5000)',
        testIntegration: 'Test Integration',
        testTitle: 'Test Integration',
        testDescription: 'Test the connection to the external reference service',
        testId: 'Test Phone Number',
        testIdPlaceholder: 'Enter phone number to test',
        testing: 'Testing...',
        testSuccess: 'Integration test successful',
        testError: 'Integration test failed',
        saveSuccess: 'External reference settings saved successfully',
        saveError: 'Failed to save external reference settings',
        lookupSuccess: 'Customer information retrieved successfully',
        lookupError: 'Failed to retrieve customer information',
        lookupTimeout: 'Request timed out while retrieving customer information',
        noCustomerFound: 'No customer information found for this phone number'
      }
    },
    billingManagement: {
      title: 'Billing Management',
      description: 'Configure billing for ticket creation'
    },
    notifications: {
      integrationSettings: 'Integration Settings',
      enable: 'Enable Push Notifications',
      apiUrl: 'API URL',
      authKey: 'Authentication Key',
      notificationId: 'Notification ID',
      notificationIdDesc: 'The notification ID used by the external notification service',
      channelType: 'Channel Type',
      channelPush: 'Push',
      channelEmail: 'Email',
      channelSms: 'SMS',
      clientType: 'Client Type',
      defaultIcon: 'Default Icon URL',
      saveSettings: 'Save Settings',
      saving: 'Saving...',
      testPushNotification: 'Test Push Notification',
      customerId: 'Customer ID',
      sendTest: 'Send Test Notification',
      sending: 'Sending...',
      testSuccess: 'Test notification sent successfully',
      errorTest: 'Error sending test notification',
      errorTestAlert: 'Error sending test notification: ',
      settingsSaved: 'Settings saved successfully',
      settingsError: 'Error saving settings'
    }
  },

  // Omni-Channel Integration
  atrium: {
    shortTitle: 'Atrium',
    title: 'The Atrium Integration',
    description:
      'Connect multiple communication channels to manage all customer interactions in one place',
    comingSoon: 'Coming soon...',
    conversations: 'The Atrium Conversations',
    noConversations: 'No conversations found',
    overview: 'The Atrium Overview',
    activeChannels: '{{count}} active channel',
    activeChannels_plural: '{{count}} active channels',
    realtimeStats: 'Real-time messaging statistics',
    settings: 'The Atrium Settings',
    agentStats: 'The Atrium agent statistics and metrics',
    filters: {
      title: 'Filters',
      active: 'Active',
      clearAll: 'Clear all',
      searchPlaceholder: 'Search conversations...',
      status: 'Status',
      priority: 'Priority',
      channel: 'Channel',
      assignedTo: 'Assigned To',
      allConversations: 'All Conversations',
      unassigned: 'Unassigned'
    },
    selectConversation: 'Select a conversation to view details',
    messenger: {
      description: 'Connect with customers via Facebook Messenger',
      title: 'Connect Facebook Messenger',
      subtitle: 'Enable your customers to reach you through Facebook Messenger',
      beforeStart: 'Before you start',
      beforeStartDesc:
        "You'll need a Facebook Page and a Facebook App with Messenger enabled. Follow these steps to get your credentials.",
      stepByStep: 'Step-by-step guide:',
      continueBtn: 'I have my credentials, continue',
      continueToTesting: 'Continue to Testing',
      successMessage: 'Messenger channel configured successfully!',
      setupWebhook: 'Setup Facebook Webhook',
      setupWebhookDesc: 'Before testing, you need to configure the webhook in your Facebook App',
      webhookStep1: 'Go to Messenger Settings in your Facebook App',
      webhookStep2: 'Find "Webhooks" section',
      webhookStep3: 'Click "Add Callback URL"',
      webhookStep4: 'Use the URL and verify token below',
      webhookUrl: 'Webhook Callback URL',
      verifyTokenFacebook: 'Verify Token (use this in Facebook)',
      subscribeFields: 'Subscribe to these webhook fields:',
      testConnection: 'Test Connection',
      testConnectionDesc: 'Make sure your webhook is verified in Facebook before testing',
      testBtn: 'Test Connection',
      connectionSuccess: 'Connection Successful!',
      connectionFailed: 'Connection Failed',
      activateBtn: 'Activate Messenger Channel',
      steps: {
        setup: 'Facebook Setup',
        config: 'Configuration',
        test: 'Test & Activate'
      },
      guide: {
        step1: {
          title: 'Go to Facebook Developers',
          desc: 'Visit developers.facebook.com and create a new app'
        },
        step2: {
          title: 'Add Messenger Product',
          desc: 'In your app dashboard, add the Messenger product'
        },
        step3: {
          title: 'Connect Your Facebook Page',
          desc: 'Select the page you want to receive messages from'
        },
        step4: {
          title: 'Generate Page Access Token',
          desc: 'Click "Generate Token" and copy it (you\'ll need this in the next step)'
        },
        step5: {
          title: 'Get Your App Secret',
          desc: 'Go to Settings → Basic and copy your App Secret'
        }
      },
      form: {
        pageId: 'Facebook Page ID',
        pageIdDesc: 'Find this in your Facebook Page Settings → About → Page ID',
        pageAccessToken: 'Page Access Token',
        pageAccessTokenDesc:
          'Generated from Messenger Settings → Access Tokens in your Facebook App',
        appSecret: 'App Secret',
        appSecretDesc: 'Found in Settings → Basic in your Facebook App',
        verifyToken: 'Verify Token',
        verifyTokenDesc: 'Custom token for webhook verification (randomly generated)'
      }
    },
    email: {
      description: 'Receive and respond to customer emails'
    },
    viber: {
      description: 'Connect with customers via Viber'
    },
    channelStatus: {
      title: 'Facebook Messenger',
      subtitle: 'Channel Status & Configuration',
      active: 'Active',
      inactive: 'Inactive',
      connectedTo: 'Connected to Facebook Messenger',
      configuredButInactive: 'Channel Configured but Inactive',
      pageId: 'Page ID',
      connectedOn: 'Connected on',
      status: 'Status',
      verified: 'Verified',
      totalConversations: 'Total Conversations',
      messagesReceived: 'Messages Received',
      messagesSent: 'Messages Sent',
      lastActivity: 'Last Activity',
      viewConfig: 'View Config',
      hideConfig: 'Hide Config',
      manageAccess: 'Manage Access',
      hideAccess: 'Hide Access',
      test: 'Test',
      testing: 'Testing...',
      disable: 'Disable',
      enable: 'Enable',
      processing: 'Processing...',
      configurationDetails: 'Configuration Details',
      dangerZone: 'Danger Zone',
      dangerZoneWarning:
        'Disconnecting this channel will permanently delete all configuration data. Active conversations must be resolved first.',
      disconnectChannel: 'Disconnect Channel',
      disconnecting: 'Disconnecting...'
    },
    liveChat: {
      title: 'Live Chat',
      description: 'Enable the widget key for partners to embed your Atrium live chat.',
      appId: 'App ID',
      saveConfig: 'Save Configuration',
      embedSnippet: 'Embed snippet',
      domains: 'Whitelisted domains',
      domainsHelp:
        'Add allowed website origins. Use full origins like https://my-site.com or wildcard subdomains like https://*.my-site.com.',
      personalization: 'Personalization',
      widgetTitle: 'Widget Title',
      defaultWidgetTitle: 'Live support',
      accentColor: 'Accent Color',
      roundness: 'Roundness',
      roundnessNone: 'None (Square)',
      roundnessNormal: 'Normal',
      roundnessFull: 'Full (Rounded)',
      confirmRemove: 'Remove live chat configuration? This will decommission the widget key.',
      errorLoad: 'Failed to load live chat configuration',
      errorEnable: 'Failed to enable live chat',
      errorRemove: 'Failed to remove live chat configuration',
      errorCopy: 'Failed to copy',
      errorSave: 'Failed to save configuration',
      errorInvalidWildcard: 'Invalid wildcard domain: {{value}}',
      errorOnlyHttp: 'Only http/https domains are allowed: {{value}}',
      errorInvalidUrl: 'Invalid domain URL: {{value}}',
      widgetPosition: 'Widget Position',
      positionBottomRight: 'Bottom Right',
      positionBottomLeft: 'Bottom Left',
      positionTopRight: 'Top Right',
      positionTopLeft: 'Top Left',
      horizontalOffset: 'Horizontal Offset (px)',
      verticalOffset: 'Vertical Offset (px)',
      offsetHelp: 'Distance from the screen edges in pixels.'
    }
  },

  bot: {
    title: 'Bot Configuration',
    subtitle: 'Configure automated responses and bot behavior',
    settings: 'Bot Settings',
    rules: 'Bot Rules',
    channel: 'Channel',
    selectChannel: 'Select a channel',
    enableAutoReplies: 'Enable Bot Auto-Replies',
    enableAutoRepliesDesc: 'When enabled, the bot will automatically respond to customer messages',
    messages: 'Messages',
    greetingMessage: 'Greeting Message',
    optional: '(Optional)',
    greetingPlaceholder: 'Hi! 👋 Welcome to FlowCXP! How can I help you today?',
    greetingSent: 'Sent automatically when a new conversation starts',
    fallbackMessage: 'Fallback Message',
    fallbackSent: "Sent when no rules match the customer's message",
    statistics: 'Statistics',
    totalRules: 'Total Rules',
    activeRules: 'Active Rules',
    totalTriggers: 'Total Triggers',
    lastTriggered: 'Last Triggered',
    searchRules: 'Search rules...',
    addRule: 'Add Rule',
    noRulesYet: 'No rules created yet',
    createFirstRule: 'Create your first rule to start automating responses',
    whenCustomerSays: 'When customer says',
    botRespondsWith: 'Bot responds with',
    priority: 'Priority',
    used: 'Used',
    times: 'times'
  }
};
